import React, { useCallback, useEffect, useState } from 'react'
import styled, { css } from 'styled-components/macro'
import Gallery from '../../common/Gallery'
import { ROUTES, TYPE_ANSWER_CLICK } from '../../../constants'
import { navigate } from '@reach/router'
import { useAppContext } from '../../../context/AppContext'
import { rem } from 'polished'
import { useAnalytics } from 'use-analytics'
import MasterPage from '../../common/MasterPage'

const Questions = () => {
  const { track, page } = useAnalytics()
  const {
    data,
    quiz: {
      answers,
      setAnswer,
      questionId,
      setQuestionId,
      startTime,
      setStartTime,
    },
  } = useAppContext()

  const [heading, setHeading] = useState(null)

  const questionIndex = questionId - 1
  const currentQuestion = data[questionIndex]
  const atLastQuestion = questionId >= data.length

  useEffect(() => {
    track('page_load')
  }, [track])

  useEffect(() => {
    page()
    if (questionIndex === 0 && !startTime) setStartTime(new Date())
    //eslint-disable-next-line
  }, [questionId])

  useEffect(() => {
    const questions = data.filter((q, i) => i === questionIndex)
    if (!!questions?.length) {
      setHeading(questions[0].text)
    }
    //eslint-disable-next-line
  }, [answers, questionId])

  const handleNextQuestion = useCallback(() => {
    // GA track
    if (answers[questionIndex].length > 0) {
      const event = `Q${questionIndex + 1}_submit`

      if (atLastQuestion) {
        track('quiz_finish', {})
      }
      track(event, {})
    }
    if (!atLastQuestion) {
      setQuestionId(questionId + 1)
    } else if (atLastQuestion) {
      navigate(ROUTES.RESULTS)
    }
    //eslint-disable-next-line
  }, [atLastQuestion, questionId, setQuestionId])

  const handleAnswerSelect = useCallback(
    answerIndex => () => {
      setAnswer({
        type: TYPE_ANSWER_CLICK,
        questionIndex,
        answerIndex,
        maxAnswerIndex: currentQuestion.maxAnswers,
        data,
      })
      setTimeout(() => handleNextQuestion(), 1000)
    },
    //eslint-disable-next-line
    [currentQuestion.maxAnswers, questionIndex, setAnswer],
  )

  return (
    <MasterPage
      heading={heading}
      caption={`Question ${questionId}`}
      showProgress
    >
      <AnswerContainer>
        <Gallery
          answers={answers}
          currentQuestion={currentQuestion}
          questionIndex={questionIndex}
          handleAnswerSelect={handleAnswerSelect}
          handleTransitionComplete={() => {}}
        />
      </AnswerContainer>
    </MasterPage>
  )
}

Questions.propTypes = {}

export default Questions

const AnswerContainer = styled.div`
  ${({ theme }) => css`
    position: relative;
    margin: 0.75em auto ${rem(18)};

    ${theme.media.md`
      margin: ${theme.space(1)} 0 ${rem(10)};
    `};

    ${theme.media.xl`
      margin-bottom: ${rem(18)};
    `};

    .flickity-enabled:focus {
      outline: none !important;
      border: none;
    }
  `}
`
